import _ from 'underscore';
import { Component } from 'react';
import styled from 'styled-components';
import withSearchResultsManagement from '~/components/common/search/with-search-results-management';
import AssetPickerTypes from '~/components/common/asset-picker/asset-picker-types';
import { media } from '~/styles';
import withAlgoliaSearch from '~/components/common/search/with-algolia-search';
import TrainingIndices from '../../algolia/training/training-indices';
import DropdownEnabledSearchBar from '../common/search/dropdown-enabled-search-bar';
import LearnerHomeSearchResult from '../../algolia/training/learner-home-search-result';

/**
  Normal Learner Search from Learner Home and University(Library) Home
  When used within a specific Library, only searches content with given Library
  */
class TrainingSearchBarBase extends Component {
  TRANSLATED_UNIVERSITY_TYPE_DISPLAY_NAME = I18n.t('common.content.university', { count: 1 });

  TRANSLATED_SEARCH_UNIVERSITY = I18n.t('js.learner.search.search_university', {
    content: this.TRANSLATED_UNIVERSITY_TYPE_DISPLAY_NAME,
  });

  TRANSLATED_SEARCH_TRAINING = I18n.t('js.learner.search.search_training');

  state = {
    query: '',
    searchWithinUniversity: !!this.props.universityId,
  };

  render() {
    return (
      <TrainingSearchBarWrapper
        onClick={this.selectSelf}
        searchWithinUniversity={this.state.searchWithinUniversity}
        selected={this.state.selected}
      >
        <DropdownEnabledSearchBar
          allowReset={this.props.allowReset}
          iconWhenUnused={this.props.iconWhenUnused}
          controlledQuery={this.state.query}
          handleItemSelect={this.props.handleItemSelect}
          onBlur={this.onBlur}
          onReset={this.props.onReset}
          placeholder={
            this.state.searchWithinUniversity ? this.TRANSLATED_SEARCH_UNIVERSITY : this.TRANSLATED_SEARCH_TRAINING
          }
          renderResult={(results, isActive) => <LearnerHomeSearchResult {...results} isActive={isActive} />}
          results={this.props.results && this.props.results.slice(0, 10)}
          search={this.search}
          searching={this.props.searching}
          showAdvancedSearchOption={!this.state.searchWithinUniversity && !this.props.hideAdvancedSearch}
          searchWithinUniversity={this.state.searchWithinUniversity}
          updateControlledQuery={this.updateControlledQuery}
          debouncedSearchTime={APP_CONSTANTS.DEBOUNCED_SEARCH_TIME.SLOW}
        />
      </TrainingSearchBarWrapper>
    );
  }

  updateControlledQuery = (query) => {
    this.setState({ query });
  };

  selectSelf = () => {
    this.setState({ selected: true });
  };

  onBlur = () => {
    this.setState({ selected: false });
    if (typeof this.props.onBlur === 'function') this.props.onBlur();
  };

  search = (query) => {
    if (query) {
      const searchId = this.props.beforeSearch();
      let filters = 'is_published:true';
      if (this.props.universityId && this.state.searchWithinUniversity) {
        filters += ` AND university_ids:${this.props.universityId}`;
      }

      if (!this.state.searchWithinUniversity) {
        filters += ` AND NOT type:${AssetPickerTypes.UDEMY}`;
      }

      this.props.search(query, this.afterSearch.bind(this, searchId), {
        offset: 0,
        length: 50,
        filters,
        // analyticsTags are used to filter data in search analytics
        analyticsTags: ['internal', 'learner', `enterprise_id:${getCurrentUser().enterpriseId}`],
      });
    } else {
      this.props.clear();
    }
  };

  afterSearch = (searchId, results) => {
    this.props.filter(results, (filteredResults) => {
      let formattedResults = this.props.format(filteredResults);
      formattedResults = _.flatten(formattedResults);

      this.props.afterSearch(searchId, formattedResults);
    });
  };
}

const TrainingSearchBarWrapper = styled.div`
  ${media.mobile} {
    ${(props) =>
      props.searchWithinUniversity && props.selected
        ? 'position: absolute;' +
          'height: 100%;' +
          'width: 100%;' +
          'background: white;' +
          'display: flex;' +
          'align-items: center;'
        : ''}

    .search-bar input {
      width: 100%;
      background-position: center right 16px;
    }

    input::-webkit-input-placeholder,
    input::placeholder {
      color: transparent;
    }

    ${(props) =>
      props.searchWithinUniversity && props.selected
        ? '.search-bar input {' +
          'background-position: center left 16px !important;' +
          '}' +
          'input::-webkit-input-placeholder,' +
          'input::placeholder {' +
          'color: #C0CBD6 !important;' +
          '}'
        : ''}

    .click-off {
      width: 100%;
    }
  }

  ${(props) => (props.searchWithinUniversity ? 'flex-grow: 1;' : '')}
`;

const TrainingSearchBar = withSearchResultsManagement(
  withAlgoliaSearch(TrainingSearchBarBase, TrainingIndices.getAll()),
);
export default TrainingSearchBar;
